<template>
  <div class="login-container">
    <!-- 新增：网站标题 -->
    <h1 class="site-title">田巡小工具{{ txType }}</h1>
    <div class="content-wrapper">
      <!-- 网站名称和公司 logo 区域 -->
      <div class="login-box">
        <h2>登录</h2>
        
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="username">用户名</label>
            <input type="text" id="username" v-model="username" placeholder="请输入用户名" required>
          </div>
          <div class="form-group">
            <label for="password">密码</label>
            <input type="password" id="password" v-model="password" placeholder="请输入密码" required>
          </div>
          <div v-if="msg" :class="{'success': isLoginSuccess, 'error':!isLoginSuccess}">
            {{ msg }}
          </div>
          <button type="submit">登录</button>
        </form>
      </div>
      <div class="logo-section">
        <img src="@/assets/logo.png" alt="公司 logo" class="logo">
        <div><h3 class="logo-text">快速反应 精准测绘 服务至上</h3></div>        
        <div class="info-section">
          <h2 class="info-item">主管单位：北京市规划和自然资源委员会昌平分局</h2>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <h2 class="info-item">技术支持：北京新益安地理信息技术有限公司(15810675393)</h2>         
          
        </div>
      </div>      
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginPage',
  data() {
    console.log("初始化",process.env.TX_SERVER_ADDRESS_BACK);
    return {      
      username: '',
      password: '',
      msg:'',
      isLoginSuccess:false,
      serverAddress:process.env.TX_SERVER_ADDRESS_BACK,
      txType:process.env.TX_TYPE||'',
    };
  },
  methods: {
    async handleLogin() {
      // 这里可以添加登录逻辑，例如发送请求到后端验证用户名和密码       
      // console.log('用户名:', this.username, '密码:', this.password);
      console.log("serverAddress:",this.serverAddress);
      const res = await axios.post(this.serverAddress +'/api/login',{
        UserID:this.username,
        PassWord:this.password,
      });
      if(res.data && res.data.code === 0){
        console.log("登录成功！");
        this.isLoginSuccess = true;
        this.msg = "登录成功！";
        localStorage.setItem('isLoggedIn',true);
        localStorage.setItem('userID',res.data.UserID);
        localStorage.setItem('userName',res.data.UserName);
        localStorage.setItem('token',res.data.token);  
        localStorage.setItem('role',res.data.Role);      
        localStorage.setItem('roleType',res.data.RoleType); 
        this.$router.push('/MainPage');
      }else{
        console.log("登录失败！",res.data);
        this.isLoginSuccess = false;
        this.msg = res.data.msg;
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f9;
  background-image: url('@/assets/bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.site-title {
  font-size: 48px;
  color: #fff;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  margin-bottom: 20px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* 新增：网站名称和公司 logo 样式 */
.logo-section {
  margin-right: 10px; /* 调整登录框和 logo 之间的间距 */
  text-align: center;
}

.logo {
  width: 150px; /* 调整 logo 大小 */
  height: auto;
  background-color: rgba(255,255,255,0.7);
  border-radius: 50%;
  margin-top: 10px;
}

.logo-text {
  font-size: 25px;
  font-family: 'Courier New', Courier, monospace;
  color:blue;
  margin-bottom: 5px;
  text-shadow: 2px 2px 2px rgba(223, 217, 217, 0.6);
}

.info-section {
  text-align: center;
  display: flex;
  flex-direction: row;
  background-color:rgba(128,150,128,0.7);
  /* border: 1px solid rgba(50,50,150,0.6); */
  padding: 10px;
}

.info-item {
  font-size: 18px;
  color: #fff;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.6);  
}

.site-name {
  font-size: 24px;
  color: #333;
}

.login-box {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 400px;
  border: 10px solid rgba(0, 0, 0, 0.1); 
}

.login-box h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #666;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.login-box button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.login-box button:hover {
  background-color: #0056b3;
}

.success {
  color: green;
  margin-bottom: 10px;
}

.error {
  color: red;
  margin-bottom: 10px;
}
</style>
